<template>
  <div>
    <Dialog :stateId="dialogId" maxWidth="960px" @dialog-closing="close" @close="close">
    <v-card v-if="show" id="bid-detail">
      <v-card-title class="primary white--text">
        <span>{{ bid?.name }}</span>
        <v-spacer/>
        <Icon
        v-if="bid"
        icon="mdi-pencil"
        iconColor="white"
        :small="false"
        tabindex="0"
        elementId="bid-detail-edit"
        :tooltipText="$t('edit')"
        @icon-clicked="requestEdit"/>
        <BaseDialogActions
        hideRefresh
        hideFullscreen
        customCancel
        elementId="bid-detail-actions"
        @close="requestClose"/>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-row v-if="!bid" class="my-12" justify="center" align="center">
          <v-progress-circular indeterminate color="primary"/>
        </v-row>

        <BidDetail v-else :bid="bid"/>
      </v-card-text>
    </v-card>
    </Dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { uniqueDialogId } from '@/utils/componentHelpers'

export default {
  name: 'BidDetailDialog',

  components: {
    Dialog: () => import('@/components/Dialog.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue'),
    BidDetail: () => import('@/components/bid/BidDetail.vue')
  },

  data: () => ({
    dialogId: uniqueDialogId('bid-detail-dialog'),
    show: false,
    bid: null,
    openRequestId: 0,
    editRequested: null
  }),

  computed: {
    ...mapGetters('account', ['allAccounts']),
    ...mapGetters('tract', ['allTimberCategories', 'allConversions', 'allLandownerTypes']),
    ...mapGetters('product', { storeProducts: 'allProducts' })
  },

  methods: {
    ...mapActions('bid', ['fetchBid']),
    ...mapActions('account', ['fetchAccounts']),
    ...mapActions('tract', ['fetchTimberCategories', 'fetchConversions', 'fetchLandownerTypes']),
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('dialog', ['openOrUpdateDialog', 'closeDialogsAtOrAbove']),

    async open (bid) {
      const requestId = ++this.openRequestId
      this.bid = null
      this.show = true
      this.openOrUpdateDialog({ id: this.dialogId, width: '960px' })
      if (!this.allAccounts.length) this.fetchAccounts()
      if (!this.storeProducts.length) this.fetchProducts({ includeByProducts: false, includeProduction: true })
      if (!this.allTimberCategories.length) this.fetchTimberCategories()
      if (!this.allConversions.length) this.fetchConversions()
      if (!this.allLandownerTypes.length) this.fetchLandownerTypes()
      const full = await this.fetchBid(bid.bidId)
      if (requestId === this.openRequestId && this.show) this.bid = full
    },

    async refresh () {
      if (!this.show || !this.bid) return
      this.bid = await this.fetchBid(this.bid.bidId)
    },

    requestEdit () {
      this.editRequested = this.bid
      this.requestClose()
    },

    requestClose () {
      this.closeDialogsAtOrAbove(this.dialogId)
    },

    close () {
      const editBid = this.editRequested
      this.editRequested = null
      this.show = false
      this.bid = null
      if (editBid) this.$emit('edit', editBid)
    }
  }
}
</script>
